import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { Link } from "react-router-dom";

const faqs = [
  {
    question: "How do I know which service is right for my business?",
    answer:
      "Each business has unique needs. If you're unsure which service to choose, we recommend scheduling a consultation with one of our experts. We'll assess your current challenges and goals to guide you toward the most suitable solution.",
  },
  {
    question:
      "What is a Market Research Report, and how can it benefit my business?",
    answer:
      "A Market Research Report provides in-depth analysis and insights into a specific market or industry. These reports include data on market size, trends, growth opportunities, competitive landscape, and consumer behaviour. Businesses use these reports to understand the market dynamics and make strategic decisions that improve growth and profitability.",
  },
  {
    question:
      "Can I request a custom research report specific to my business needs?",
    answer:
      "Yes, we offer Custom Research & Consulting services tailored to your business's specific challenges and objectives. Whether you're entering a new market, launching a product, or looking to gain a competitive edge, we will design a research solution that meets your unique requirements.",
  },

  {
    question: "How frequently are your reports updated?",
    answer:
      "Our reports are updated regularly to reflect the latest market trends, data, and regulatory changes. This ensures that you receive the most current and relevant information to make informed decisions.",
  },

  {
    question: "How can I access your reports?",
    answer:
      "You can access our reports by purchasing them directly from our website. If you require custom research, you can contact us to discuss your needs and receive a tailored proposal.",
  },

  {
    question:
      "What is the typical turnaround time for custom research projects?",
    answer:
      "Turnaround times for Custom Research depend on the complexity and scope of the project. However, we strive to deliver comprehensive and actionable reports within an agreed-upon timeframe, typically ranging from a few weeks to a few months.",
  },
  {
    question:
      "How do I know if my business needs ESG Consulting or Market Research?",
    answer: `If your business is facing regulatory challenges, looking to build sustainable growth strategies, or needs to improve investor and stakeholder trust, ESG Consulting is essential.
If you're exploring new markets, launching products, or optimizing performance, Market Research will provide you with valuable insights to make data-driven decisions.
Feel free to consult with our experts to assess your business needs.
`,
  },
];

const EsgServices = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-4 pb-16 sm:pb-24">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 font-inter">
        Our ESG Consulting Services
      </h2>

      <div className="">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border-b border-gray-300 py-3 sm:py-4 lg:py-5 transition-all duration-200 hover:bg-gray-50"
          >
            <div
              className="flex justify-between items-start sm:items-center cursor-pointer gap-4"
              onClick={() => toggleFAQ(index)}
            >
              <h3 className="text-base sm:text-lg lg:text-xl font-semibold font-poppins pr-8">
                {faq.question}
              </h3>
              <div className="flex-shrink-0 mt-1 sm:mt-0">
                {activeIndex === index ? (
                  <FiChevronUp className="text-lg sm:text-xl text-[#1c1b1f]" />
                ) : (
                  <FiChevronDown className="text-lg sm:text-xl text-[#1c1b1f]" />
                )}
              </div>
            </div>

            {activeIndex === index && (
              <div className="mt-2 sm:mt-3 font9 whitespace-pre-line font-poppins text-sm sm:text-base lg:text-lg transition-all duration-300 ease-in-out">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EsgServices;
